// extracted by css-extract-rspack-plugin
export default {"cls1":"ChatInterface-cls1_wHp","cls2":"ChatInterface-cls2_a_K ChatInterface-cls1_wHp"};